export default "__VITE_ASSET__Cmj_DqBZ__"